module.exports = __webpack_public_path__ + "img/a1.7690d5a3.png";